"use client";

import { useEffect, useState } from "react";
import "./Tripschedule.css";
import axiosInstance from "../../utils/axiosInstance.js";
import { BASE_URL } from "../../config.js";

function Tripschedule() {
  const token = JSON.parse(localStorage.getItem("NagpurProperties"))?.token;
  const [GetMachineName, setGetMachinename] = useState([]);
  const [GetDriverName, setGetDriverName] = useState([]);
  const [GetProjectName, setGetProjectName] = useState([]);
  const [ScheduleFormShow, setScheduleFormShow] = useState(false);
  const [SiteName, setSiteName] = useState("");
  const [DriverName, setDriverName] = useState("");
  const [MachineName, setMachineName] = useState("");
  const [StartDate, setStartDate] = useState("");
  const [EndDate, setEndDate] = useState("");
  const [Trips, setTrips] = useState([]);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [selectedMachine, setSelectedMachine] = useState(null);
  const [openOptionsMenu, setOpenOptionsMenu] = useState(null);
  const [editingTrip, setEditingTrip] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [search, setSearch] = useState("");
  useEffect(() => {
    async function getAllMachineName() {
      try {
        const response = await axiosInstance.get(
          `${BASE_URL}/machines/singleMechine`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        setGetMachinename(response.data);
        console.log(response.data);
      } catch (error) {
        console.log(error);
      }
    }
    getAllMachineName();
  }, []);

  useEffect(() => {
    async function getAllDriver() {
      try {
        const response = await axiosInstance.get(
          `${BASE_URL}/Driver/show-All`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        setGetDriverName(response.data);
        console.log(response.data);
      } catch (error) {
        console.log(error);
      }
    }
    getAllDriver();
  }, []);

  useEffect(() => {
    async function getAllProjectName() {
      try {
        const response = await axiosInstance.get(
          `${BASE_URL}/show-AllProject`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        setGetProjectName(response.data);
        console.log(response.data);
      } catch (error) {
        console.log(error);
      }
    }
    getAllProjectName();
  }, []);

  async function handleSubmitscheduleForm(e) {
    e.preventDefault();
    const scheduleData = {
      machineId: MachineName,
      driverId: DriverName,
      siteName: SiteName,
      startDate: StartDate,
      endDate: EndDate,
    };

    try {
      let response;
      if (isEditMode && editingTrip) {
        response = await axiosInstance.put(
          `${BASE_URL}/trips/${editingTrip.id}`,
          scheduleData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        if (response.status === 200) {
          alert("Schedule updated successfully");
          fetchTrips();
        }
      } else {
        response = await axiosInstance.post(`${BASE_URL}/trips`, scheduleData, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
        if (response.status === 200) {
          alert("Schedule created successfully");
          fetchTrips();
        }
      }

      setScheduleFormShow(false);
      setIsEditMode(false);
      setEditingTrip(null);
      setMachineName("");
      setDriverName("");
      setSiteName("");
      setStartDate("");
      setEndDate("");
    } catch (error) {
      console.log(error);
      alert("Error saving schedule");
    }
  }

  async function fetchTrips() {
    try {
      const response = await axiosInstance.get(`${BASE_URL}/trips`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      console.log(response.data);
      setTrips(response.data);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    fetchTrips();
  }, []);

  function handleEditTrip(trip) {
    console.log(trip);
    setEditingTrip(trip);
    setIsEditMode(true);
    setMachineName(trip.machine.id);
    setDriverName(trip.driver.id);
    setSiteName(trip.siteName);
    setStartDate(trip.startDate.split("T")[0]);
    setEndDate(trip.endDate.split("T")[0]);
    setScheduleFormShow(true);
    setOpenOptionsMenu(null);
  }

  async function handleDeleteTrip(tripId) {
    if (window.confirm("Are you sure you want to delete this trip?")) {
      try {
        const response = await axiosInstance.delete(
          `${BASE_URL}/trips/${tripId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        console.log(response);
        if (response.status === 204) {
          alert("Trip deleted successfully");
          fetchTrips();
        }
      } catch (error) {
        console.log(error);
        alert("Error deleting trip");
      }
    }
    setOpenOptionsMenu(null);
  }

  function toggleOptionsMenu(tripId) {
    setOpenOptionsMenu(openOptionsMenu === tripId ? null : tripId);
  }

  const FilterData = Trips.filter((trip) => {
    return (
      trip.machine.machineName.toLowerCase().includes(search.toLowerCase()) ||
      trip.driver.name.toLowerCase().includes(search.toLowerCase()) ||
      trip.siteName.toLowerCase().includes(search.toLowerCase())
    );
  });

  return (
    <div className="Tripschedule-main-wrapper">
      {/* <div className="Tripschedule-header">
        <h1 className="Tripschedule-title">Trip Schedule Management</h1>
      </div> */}

      {/* <div className="Tripschedule-header">
        <div className="machine-header-content">
          <h1 className="Tripschedule-title">Trip Schedule Management</h1>
          <p className="Tripschedule-subtitle">
            Real-time insights for informed decision-making
          </p>
        </div>
      </div> */}

      <div className="Tripschedule-container">
        <div className="Tripschedule-search-container">
          <div className="Tripschedule-search-wrapper">
            <svg
              className="Tripschedule-search-icon"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
            <input
              className="Tripschedule-search-input"
              type="search"
              placeholder="Search trips, machines, or drivers..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>

        <div className="Tripschedule-button-container">
          <button
            className="Tripschedule-schedule-button"
            onClick={() => setScheduleFormShow(true)}
          >
            <svg
              className="Tripschedule-button-icon"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 4v16m8-8H4"
              />
            </svg>
            Schedule New Trip
          </button>
        </div>
      </div>

      {/* Schedule Form Modal */}
      {ScheduleFormShow && (
        <div className="Tripschedule-modal-overlay">
          <div className="Tripschedule-form-container">
            <div className="Tripschedule-form-header">
              <h2 className="Tripschedule-form-title">
                {isEditMode ? "Edit Trip Schedule" : "Schedule New Trip"}
              </h2>
              <button
                className="Tripschedule-close-button"
                onClick={() => {
                  setScheduleFormShow(false);
                  setIsEditMode(false);
                  setEditingTrip(null);
                  setMachineName("");
                  setDriverName("");
                  setSiteName("");
                  setStartDate("");
                  setEndDate("");
                }}
              >
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            <form
              className="Tripschedule-form"
              onSubmit={handleSubmitscheduleForm}
            >
              <div className="Tripschedule-form-grid">
                <div className="Tripschedule-form-group">
                  <label className="Tripschedule-label">Machine</label>
                  <select
                    className="Tripschedule-select-machine"
                    value={MachineName}
                    onChange={(e) => setMachineName(e.target.value)}
                    required
                  >
                    <option className="Tripschedule-option" value="">
                      Select Machine
                    </option>
                    {GetMachineName.map((machine) => (
                      <option
                        className="Tripschedule-option"
                        key={machine.id}
                        value={machine.id}
                      >
                        {machine.machineName}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="Tripschedule-form-group">
                  <label className="Tripschedule-label">Driver</label>
                  <select
                    className="Tripschedule-select-driver"
                    value={DriverName}
                    onChange={(e) => setDriverName(e.target.value)}
                    required
                  >
                    <option className="Tripschedule-option" value="">
                      Select Driver
                    </option>
                    {GetDriverName.map((driver) => (
                      <option
                        className="Tripschedule-option"
                        key={driver.id}
                        value={driver.id}
                      >
                        {driver.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="Tripschedule-form-group">
                  <label className="Tripschedule-label">Project Site</label>
                  <select
                    className="Tripschedule-select-project"
                    value={SiteName}
                    onChange={(e) => setSiteName(e.target.value)}
                    required
                  >
                    <option className="Tripschedule-option" value="">
                      Select Project
                    </option>
                    {GetProjectName.map((project) => (
                      <option
                        className="Tripschedule-option"
                        key={project.id}
                        value={editingTrip ? Trips.siteName : project.name}
                      >
                        {project.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="Tripschedule-form-group">
                  <label className="Tripschedule-label">Start Date</label>
                  <input
                    className="Tripschedule-date-input"
                    type="date"
                    value={StartDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    required
                    min={new Date().toISOString().split("T")[0]}
                  />
                </div>

                <div className="Tripschedule-form-group">
                  <label className="Tripschedule-label">End Date</label>
                  <input
                    className="Tripschedule-date-input"
                    type="date"
                    value={EndDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    required
                    min={new Date().toISOString().split("T")[0]}
                  />
                </div>
              </div>

              <div className="Tripschedule-form-actions">
                <button
                  type="button"
                  className="Tripschedule-cancel-button"
                  onClick={() => {
                    setScheduleFormShow(false);
                    setIsEditMode(false);
                    setEditingTrip(null);
                    setMachineName("");
                    setDriverName("");
                    setSiteName("");
                    setStartDate("");
                    setEndDate("");
                  }}
                >
                  Cancel
                </button>
                <button type="submit" className="Tripschedule-submit-button">
                  {isEditMode ? "Update Schedule" : "Create Schedule"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Trips Grid */}
      <div className="Tripschedule-trips-section">
        {/* <div className="Tripschedule-trips-header">
          <h2 className="Tripschedule-trips-title">Scheduled Trips</h2>
        </div> */}

        <div className="Tripschedule-trips-grid">
          {FilterData.length > 0 ? (
            FilterData.map((trip) => (
              <div className="Tripschedule-trip-card" key={trip.id}>
                <div className="Tripschedule-trip-header">
                  <h3 className="Tripschedule-trip-title">
                    {trip.machine.machineName || ""}
                  </h3>
                  {/* <div className="Tripschedule-trip-status">
                    <span className="Tripschedule-status-badge">Active</span>
                  </div> */}
                  <div className="Tripschedule-trip-actions">
                    <div className="Tripschedule-options-container">
                      <button
                        className="Tripschedule-options-button"
                        onClick={() => toggleOptionsMenu(trip.id)}
                      >
                        <svg
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
                          />
                        </svg>
                      </button>
                      {openOptionsMenu === trip.id && (
                        <div className="Tripschedule-options-menu">
                          <button
                            className="Tripschedule-option-item Tripschedule-edit-option"
                            onClick={() => handleEditTrip(trip)}
                          >
                            <svg
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                              />
                            </svg>
                            Edit
                          </button>
                          <button
                            className="Tripschedule-option-item Tripschedule-delete-option"
                            onClick={() => handleDeleteTrip(trip.id)}
                          >
                            <svg
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                              />
                            </svg>
                            Delete
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="Tripschedule-trip-details">
                  <div className="Tripschedule-trip-info">
                    <svg
                      className="Tripschedule-info-icon"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                      />
                    </svg>
                    <p className="Tripschedule-trip-driver">
                      <strong>Driver:</strong> {trip.driver?.name}
                    </p>
                  </div>

                  <div className="Tripschedule-trip-info">
                    <svg
                      className="Tripschedule-info-icon"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                      />
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                    </svg>
                    <p className="Tripschedule-trip-site">
                      <strong>Site:</strong> {trip.siteName}
                    </p>
                  </div>

                  <div className="Tripschedule-trip-dates">
                    <div className="Tripschedule-date-item">
                      <span className="Tripschedule-date-label">Start:</span>
                      <span className="Tripschedule-trip-start-date">
                        {new Date(trip.startDate).toLocaleDateString()}
                      </span>
                    </div>
                    <div className="Tripschedule-date-item">
                      <span className="Tripschedule-date-label">End:</span>
                      <span className="Tripschedule-trip-end-date">
                        {new Date(trip.endDate).toLocaleDateString()}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="Tripschedule-trip-button-container">
                  <button
                    className="Tripschedule-driver-button"
                    onClick={() => setSelectedDriver(trip.driver)}
                  >
                    <svg
                      className="Tripschedule-button-icon"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                      />
                    </svg>
                    Driver Details
                  </button>
                  <button
                    className="Tripschedule-machine-button"
                    onClick={() => setSelectedMachine(trip.machine)}
                  >
                    <svg
                      className="Tripschedule-button-icon"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z"
                      />
                    </svg>
                    Machine Details
                  </button>
                </div>
              </div>
            ))
          ) : (
            <div className="Tripschedule-empty-state">
              <svg
                className="Tripschedule-empty-icon"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                />
              </svg>
              <p className="Tripschedule-no-trips">No trips scheduled yet.</p>
              <p className="Tripschedule-empty-subtitle">
                Create your first trip schedule to get started.
              </p>
            </div>
          )}
        </div>
      </div>

      {/* Driver Details Modal */}
      {selectedDriver && (
        <div className="Tripschedule-modal-overlay">
          <div className="Tripschedule-driver-modal">
            <div className="Tripschedule-driver-modal-content">
              <div className="Tripschedule-modal-header">
                <h2 className="Tripschedule-driver-modal-title">
                  Driver Details
                </h2>
                <button
                  className="Tripschedule-driver-close-button"
                  onClick={() => setSelectedDriver(null)}
                >
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>

              <div className="Tripschedule-modal-body">
                <div className="Tripschedule-driver-info">
                  <div className="Tripschedule-info-item">
                    <span className="Tripschedule-info-label">Name:</span>
                    <span className="Tripschedule-driver-name">
                      {selectedDriver.name}
                    </span>
                  </div>
                  <div className="Tripschedule-info-item">
                    <span className="Tripschedule-info-label">Email:</span>
                    <span className="Tripschedule-driver-email">
                      {selectedDriver.email}
                    </span>
                  </div>
                  <div className="Tripschedule-info-item">
                    <span className="Tripschedule-info-label">Status:</span>
                    <span
                      className={`Tripschedule-driver-status ${selectedDriver.driverStatus?.toLowerCase()}`}
                    >
                      {selectedDriver.driverStatus}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Machine Details Modal */}
      {selectedMachine && (
        <div className="Tripschedule-modal-overlay">
          <div className="Tripschedule-machine-modal">
            <div className="Tripschedule-machine-modal-content">
              <div className="Tripschedule-modal-header">
                <h2 className="Tripschedule-machine-modal-title">
                  Machine Details
                </h2>
                <button
                  className="Tripschedule-machine-close-button"
                  onClick={() => setSelectedMachine(null)}
                >
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>

              <div className="Tripschedule-modal-body">
                <div className="Tripschedule-machine-details-grid">
                  <div className="Tripschedule-info-item">
                    <span className="Tripschedule-info-label">Name:</span>
                    <span className="Tripschedule-machine-name">
                      {selectedMachine.machineName}
                    </span>
                  </div>
                  <div className="Tripschedule-info-item">
                    <span className="Tripschedule-info-label">Type:</span>
                    <span className="Tripschedule-machine-type">
                      {selectedMachine.mechinetype}
                    </span>
                  </div>
                  <div className="Tripschedule-info-item">
                    <span className="Tripschedule-info-label">Model:</span>
                    <span className="Tripschedule-machine-model">
                      {selectedMachine.model}
                    </span>
                  </div>
                  <div className="Tripschedule-info-item">
                    <span className="Tripschedule-info-label">
                      Manufacturer:
                    </span>
                    <span className="Tripschedule-machine-manufacturer">
                      {selectedMachine.manufacturer}
                    </span>
                  </div>
                  <div className="Tripschedule-info-item">
                    <span className="Tripschedule-info-label">Location:</span>
                    <span className="Tripschedule-machine-location">
                      {selectedMachine.currentLocation}
                    </span>
                  </div>
                  <div className="Tripschedule-info-item">
                    <span className="Tripschedule-info-label">
                      Fuel Capacity:
                    </span>
                    <span className="Tripschedule-machine-fuel-capacity">
                      {selectedMachine.fuleCapacity}
                    </span>
                  </div>
                  <div className="Tripschedule-info-item">
                    <span className="Tripschedule-info-label">Operator:</span>
                    <span className="Tripschedule-machine-operator">
                      {selectedMachine.operatorName}
                    </span>
                  </div>
                  <div className="Tripschedule-info-item">
                    <span className="Tripschedule-info-label">
                      Purchase Date:
                    </span>
                    <span className="Tripschedule-machine-purchase-date">
                      {selectedMachine.purchaseDate}
                    </span>
                  </div>
                  <div className="Tripschedule-info-item">
                    <span className="Tripschedule-info-label">
                      Purchase Price:
                    </span>
                    <span className="Tripschedule-machine-purchase-price">
                      {selectedMachine.purchasePrice}
                    </span>
                  </div>
                  <div className="Tripschedule-info-item">
                    <span className="Tripschedule-info-label">
                      Serial Number:
                    </span>
                    <span className="Tripschedule-machine-serial-number">
                      {selectedMachine.serialNumber}
                    </span>
                  </div>
                  <div className="Tripschedule-info-item Tripschedule-full-width">
                    <span className="Tripschedule-info-label">
                      Description:
                    </span>
                    <span className="Tripschedule-machine-description">
                      {selectedMachine.description}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Tripschedule;
